import React from 'react'
import SignInButton from './SignInButton'

const Login = () => {
    return (
        <div style={{top: '50%', textAlign: 'center', width: '100%', minHeight:530 }}>
            <div className="chat-nav" style={{ alignItems: 'center' }}>
                    <a href="https://dupont.sharepoint.com/sites/IntranetV2" className="myRed-link" target="_blank">&lt; Visit My<b>Red</b></a>
                    <h1 className="chat-header">
                        <a href='https://dupont.sharepoint.com/sites/ITMatters/SitePages/Generative-AI-at-DuPont.aspx' target="_blank" style={{ color: '#fff', fontSize: 12, textDecoration: 'none', fontWeight: 'normal', verticalAlign: 'middle' }}>About</a>
                    </h1>
                </div>
            <div style={{ lineHeight: 2 }}>
                <p>Please click on Sign in button to enter the chat room.</p>
                <div style={{ margin: 'auto' }}>
                    <SignInButton />
                </div>
            </div>
        </div>
    )
}

export default Login